export default __webpack_public_path__ + "static/media/Sweet-Almond-Bottle.cbcf0af8.png";